// libraries.
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";

// hooks.
import { getPublicationPrice } from "@pages/InventoryPage/modules/InventorySummary/components/shared/utils/getPublicationPrice";
import { useGetLeadDetailInfo } from "@store/apiSlices/leadDetail/leadDetail.hooks";
import { useGetInventoryPropertyInfo } from "@store/apiSlices/inventoryPropertyInfo/inventoryPropertyInfo.hook";
import { useApplyRangeToPublicationPrice } from "@pages/InventoryPage/modules/InventorySummary/components/shared/hooks/applyRangeToPublicationPrice";

// utils.
import { formatPrice } from "@utils/formatPrice.utils";
import {
  calculatePercentageInPrice,
  percentageToApplyInRelatedPricesCO,
} from "@shared/DashboardComponentsSummary/components/utils";
import { VIMCard } from "@domains/VIM/VIMCard";
import {
  getSelectedOption,
  getSuggestionOption,
} from "@domains/VIM/slices/vim.slice";

export const PublicationPrice = () => {
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();

  const pricePublicationInput = watch("publicationPrice");
  const applyPercentageToPrices = watch("applyPercentageToPrices");
  const leader = watch("leader");

  const { applyRangeToPublicationPrice } = useApplyRangeToPublicationPrice();

  const { area } = useGetLeadDetailInfo();

  const selectedOption = useSelector(getSelectedOption);
  const suggestionOption = useSelector(getSuggestionOption);

  const { publicationPrice: defaultPublicationPrice } =
    useGetInventoryPropertyInfo();

  const basePublicationPriceCO = getPublicationPrice(
    defaultPublicationPrice,
    selectedOption,
    suggestionOption,
  );

  const isDisabled = Boolean(selectedOption || suggestionOption);
  const publicationPriceM2 =
    Number(pricePublicationInput ?? basePublicationPriceCO) / area;

  useEffect(() => {
    setValue("publicationPrice", basePublicationPriceCO);
  }, [basePublicationPriceCO, setValue]);

  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        <div>Precio Publicado</div>
        <input
          data-testid="publicationPriceInput"
          disabled={isDisabled}
          {...register("publicationPrice", {
            onChange: (e) => {
              if (applyPercentageToPrices) {
                const priceMin = calculatePercentageInPrice(
                  e.target.value,
                  false,
                  percentageToApplyInRelatedPricesCO,
                );
                setValue("minPublicationPrice", priceMin, {
                  shouldDirty: true,
                });
              }
            },
            validate: (value) =>
              applyRangeToPublicationPrice({
                defaultPrice: basePublicationPriceCO,
                leader,
                price: value,
              }),
            valueAsNumber: true,
          })}
          type="text"
          className="rounded-3 p-2"
        />
      </div>

      <div className="d-flex gap-2 align-items-center">
        <VIMCard />
        <div className="d-flex justify-content-end w-100">
          <small className="text-white">
            Valor por m²: {formatPrice(publicationPriceM2) || 0}
          </small>
        </div>
      </div>
      {errors.publicationPrice && (
        <small className="d-flex justify-content-end text-danger fw-bold">
          {String(errors.publicationPrice.message)}
        </small>
      )}
    </>
  );
};
